const localStorageGateway = {
  get: (name) => {
    const rawData = window.localStorage.getItem(name);
    if (!rawData) {
      return null;
    }

    const item = JSON.parse(rawData);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(name);
      return null;
    }

    try {
      const jsonData = JSON.parse(item.value);
      return jsonData;
    } catch (error) {
      return item.value;
    }
  },
  set: (name, data, ttl) => {
    const now = new Date();

    let stringifyData = null;
    if (typeof data !== 'string') {
      stringifyData = JSON.stringify(data);
    }

    const item = {
      value: stringifyData || data,
      expiry: now.getTime() + ttl,
    };

    window.localStorage.setItem(name, JSON.stringify(item));
  },
};

export default localStorageGateway;
